import {
    Box,
    CircularProgress,
    Grid,
    Stack,
    Typography
  } from "@mui/material";
  import { GeoPoint, collection, getFirestore, query, where } from "firebase/firestore";
  import React, { useEffect } from "react";
  import AppBarHome from "../components/AppBar/Home";
  import LeafletMap from "../components/LeafletMap";
  import SpeciesSearch from "../components/SpeciesSearch";
  import { getAllData } from "../libs/firebase/firestore/getAllData";
  import { getQueryAllData } from "../libs/firebase/firestore/getQueryAllData";
  import { useNavigateToTop } from "../libs/useNavigateToTop";
import { getAuth } from "firebase/auth";
import AppBarAccount from "../components/AppBar/Account";
  
  function ScreenAccount({}) {
    const navigate = useNavigateToTop();
  
    // State for tasks data
    const [bonsaiGuides, setBonsaiGuides] = React.useState([]);
  
    // loading state
    const [loading, setLoading] = React.useState(true);
  
    const handleBonsaiGuideClick = (guideId) => {
      navigate(`/bonsai-guide/${guideId}`);
    };
  
   
  
    useEffect(() => {
        const currentUser = getAuth().currentUser;
        const db = getFirestore();
        const q = query(collection(db, "bonsai-guides"),
          where("userId", "==", currentUser.uid)
        );
        
        
        getQueryAllData(q, (bonsaiGuidesData) => {
            setBonsaiGuides(bonsaiGuidesData);
            setLoading(false);
        });
    }, []);
  

    const filteredBonsaiGuides = bonsaiGuides;
  
    return (
      <Box>
        <AppBarAccount />
        <Box
          sx={{
            padding: "1rem",
            margin: "auto",
            // maxWidth: "1200px",
          
          }}
        >
        <Box
          style={{
            margin: "auto 0",
          }}
        > 
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
  
        {/* Title and description */}
          <Typography variant="h4">My Guides</Typography>
          <Typography gutterBottom
            sx={{
              marginBottom: "1rem",
            }}
          >
            Here is a list of your bonsai guides.
          </Typography>
  
        {/* SHows each bonsai guide as a card */}
          <Stack
            direction="row"
            spacing={2}
            style={{
              flexWrap: "wrap",
              overflowY:"auto"
            }}
          >
            
  
          {loading && (
            <Box
              style={{
                textAlign: "center",
                margin: "2rem 0rem",
              }}
            >
              <CircularProgress />
            </Box>
          )}
            {filteredBonsaiGuides.map((bonsaiGuide) => {
              return (
                <Box
                key={bonsaiGuide.storageDocumentId}
                style={{
                  padding: "1rem",
                  margin: "1rem",
                  marginLeft:"0rem",
                  width: "100%",
                  border: "2px solid black",
                  boxShadow: "4px 4px 0px 0px rgb(109 112 108)",
                  borderRadius: ".3rem .3rem .3rem .3rem",
                  position: "relative",
                  zIndex: 1,
                }}
                onClick={()=> {
                  handleBonsaiGuideClick(bonsaiGuide.storageDocumentId);
                }}
              >
                <Grid container>
                  <Grid item xs={12}
                  >
                    
          <span style={{ fontStyle: "italic", fontWeight:600 }}>  {bonsaiGuide.stage} </span> of the 
          <span style={{ fontStyle: "italic", fontWeight:600 }}> {bonsaiGuide.commonName} ({bonsaiGuide.scientificName})</span> bonsai tree.
                    
                    </Grid>
                  
                  <Grid item xs={6}>
                  <Typography>Created: {(bonsaiGuide.timeDateCreated)? bonsaiGuide.timeDateCreated.toDate().toLocaleDateString(): null}</Typography>
                    
                    </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">Votes: {bonsaiGuide.upVotes? bonsaiGuide.upVotes.length : 0} /{bonsaiGuide.downVotes? bonsaiGuide.downVotes.length : 0}</Typography>
                    </Grid>
                  </Grid>
              </Box>
              );
            })}
            </Stack>
          </Grid>
          </Grid>
  
          
        </Box>
        
        </Box>
      </Box>
    );
  }
  
  export default ScreenAccount;
  